import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";
import { enqueueSnackbar } from "notistack";
import { resolveApiUrl } from "../../../helpers/serverUrl";

function* loginUser({ payload: { user, navigate } }) {
  try {
    console.log("🔄 Logging in user:", user);

    const response = yield call(() =>
      axios.post(
        resolveApiUrl("/auth/login"),
        {
          username: user.username,
          password: user.password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
    );

    console.log("✅ Login API Success:", response);

    // ✅ Destructure from response.data instead of response
    const {
      access_token,
      refresh_token,
      token_type,
      user: userDetails,
    } = response.data;

    if (!access_token || !userDetails) {
      yield put(apiError("Invalid login response format."));
      return;
    }

    localStorage.setItem(
      "authUser",
      JSON.stringify({
        token: access_token,
        refreshToken: refresh_token,
        tokenType: token_type,
        user: userDetails,
      })
    );

    yield put(loginSuccess(response.data)); // Also pass response.data, not full response
    enqueueSnackbar("Logged in successfully!", { variant: "success" });
    navigate("/dashboard");

  } catch (error) {
    console.error("❌ Login error in saga:", error);
    const message =
      error?.response?.data?.message || error.message || "Login failed";
    yield put(apiError(message));
  }
}



function* logoutUser({ payload: { navigate } }) {
  try {
    localStorage.removeItem("authUser");
    yield put(logoutUserSuccess());
    navigate("/login");
  } catch (error) {
    console.error("Logout error:", error);
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
